module.exports = __webpack_public_path__ + "img/TradiNext-logo.31450b4f.png";